import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { switchMap } from 'rxjs/operators';
import { AngularFireDatabase , AngularFireList} from '@angular/fire/database';
import { Observable, Subject, asapScheduler, pipe, of, from, interval, merge, fromEvent } from 'rxjs';
import { Router } from "@angular/router";
import { ActionSequence } from 'selenium-webdriver';
import { Action } from 'rxjs/internal/scheduler/Action';
import { stringify } from '@angular/compiler/src/util';


@Component({
  selector: 'app-paneladmin',
  templateUrl: './paneladmin.component.html',
  styleUrls: ['./paneladmin.component.css']
})
export class PaneladminComponent implements OnInit {


  list: AngularFireList<any>;


  itemArray:any = [];

  constructor(public db: AngularFireDatabase,private httpClient: HttpClient,private router: Router) {
    this.list = db.list('jpipcoincheck')
  }
  ngOnInit(): void {

    this.list.snapshotChanges().subscribe(actions=>{
      actions.forEach(action=>{
         let kings = action.payload.toJSON();
         this.itemArray.push(kings)

      })

    })
  }

  


}
